import { inject, Injectable, signal } from '@angular/core';
import { UsersDataService } from '@app/shared/services/users-data.service';
import { CooperationUser } from '@app/shared/types/models/cooperation/cooperation-user.model';
import { CooperationUserDTO } from '../dtos/cooperation/cooperation-user.dto';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class CooperationUserFactory extends AbstractFactory<CooperationUserDTO, CooperationUser> {
  private readonly usersDataService = inject(UsersDataService);

  public produce(item: CooperationUserDTO): CooperationUser {
    return new CooperationUser({
      id: item.id,
      cooperationId: item.cooperationId,
      user: item.user ? this.usersDataService.getById(item.user.id) : signal(undefined)
    });
  }
}
